import AccessTimeRoundedIcon from "@mui/icons-material/AccessTimeRounded";
import { Box, Stack, Typography } from "@mui/material";
import type { PublicCheckoutSession } from "../api/types";
import { formatAmount, formatExpiresAt } from "../utils/format";

interface Props {
  session: PublicCheckoutSession;
}

export function SessionSummary({ session }: Props) {
  return (
    <Box>
      {/* A quién le paga el cliente: el dato de confianza que importa (el candado
          de "pago seguro" ya vive en el header, no lo repetimos). */}
      <Typography
        variant="overline"
        sx={{ color: "text.secondary", letterSpacing: 0.6, fontWeight: 600 }}
      >
        Le pagás a {session.merchantName}
      </Typography>

      <Typography variant="h4" fontWeight={700} sx={{ mt: 0.25, mb: 0.5 }}>
        {formatAmount(session.amount, session.currency, session.uiConfig?.locale)}
      </Typography>

      {session.description ? (
        <Typography variant="body2" color="text.secondary">
          {session.description}
        </Typography>
      ) : null}

      {session.expiresAt ? (
        <Stack direction="row" alignItems="center" spacing={0.75} mt={2}>
          <AccessTimeRoundedIcon sx={{ fontSize: 15, color: "text.secondary" }} />
          <Typography variant="caption" color="text.secondary">
            Vence {formatExpiresAt(session.expiresAt, session.uiConfig?.locale)}
          </Typography>
        </Stack>
      ) : null}
    </Box>
  );
}
